export const GITHUB_URL = "https://github.com/bornayo7";
export const LINKEDIN_URL = "https://www.linkedin.com/in/yashbaruah/";
export const EMAIL = "yashbaruah@hotmail.com";
export const EMAIL_URL = `mailto:${EMAIL}`;
export const REPO_URL = "https://github.com/bornayo7/personal-website";
export const SITE_URL = "https://yashbaruah.com";
